// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"298":"727973242bb33abd","888":"a5740330840052e7"}[chunkId] + ".css";
};